export interface UserApproverRoleDTO {
    roleName?: string;
    contextName?: string;
    profileName?: string;
    approverRoleName?: string;
    approverRoleLevel?: string;
    idbApps?: string;
}
